/**
 * Brand constants for Mirror by SwitchFit.
 * Big Lift Studios owns SwitchFit and Mirror by SwitchFit (this product).
 * Change these when rebranding; internal identifiers (event names, config vars) may stay for compatibility.
 */
export const PRODUCT_NAME = "Mirror by SwitchFit";
export const PRODUCT_NAME_SHORT = "Mirror";
export const STUDIO_NAME = "Big Lift Studios";
export const STUDIO_URL = "https://biglift.studio";

/** Statement descriptor suffix (Stripe). Dashboard prefix should be "BIGLIFTSTUDIOS " → full: BIGLIFTSTUDIOS MIRROR */
export const STATEMENT_DESCRIPTOR_SUFFIX = "MIRROR";
export const STATEMENT_DESCRIPTOR_FULL = "BIGLIFTSTUDIOS MIRROR";

export const STUDIO_BYLINE = `a product of ${STUDIO_NAME}`;
export const PRODUCT_BYLINE = `${PRODUCT_NAME}, ${STUDIO_BYLINE}`;
